'use client'
import { useState, useEffect } from 'react'
import NextLink from 'next/link';
import { PrismicNextImage } from '@prismicio/next'
import { MegaNav, Search, AlertBanner } from '@/components';
import SearchButton from '@/assets/images/icons/search-button-26x26.svg'
import MenuButton from '@/assets/images/icons/menu-button-new.svg'

interface HeaderProps {
  core?: any | null;
  page?: any | null;
  sections?: any | null;
}

const Header: React.FC<HeaderProps> = ({ core, page, sections }) => {
  const [menuState, setMenuState] = useState(false)
  const [searchState, setSearchState] = useState(false)
  const [showHeader, setShowHeader] = useState(true)
  const [lastScrollY, setLastScrollY] = useState(0)

  // 🔄 Scroll handler
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY

      if (currentScrollY < 50 || currentScrollY < lastScrollY) {
        setShowHeader(true)
      } else {
        setShowHeader(false)
      }

      setLastScrollY(currentScrollY)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [lastScrollY])

  useEffect(() => {
    if (!page?.data?.hide_header_and_footer) return;

    const killChatbot = () => {
      const el = document.getElementById("dx_chatbot_fab_wrapper_id");
      if (el) {
        el.remove();
      }
    };

    killChatbot();

    const obs = new MutationObserver(killChatbot);
    obs.observe(document.body, { childList: true, subtree: true });

    return () => obs.disconnect();
  }, [page?.data?.hide_header_and_footer]);


  return (
    <header className={`sticky top-0 z-50 transition-transform duration-300 ${showHeader ? 'translate-y-0' : '-translate-y-full'}`}>
      <AlertBanner core={core} />
      <div className="bg-white p-4 font-fellix shadow">
        <div className="grid grid-cols-12 gap-0 mx-auto px-4 md:px-8 lg:px-12">
          <div className="col-span-6 md:col-span-4">
            <NextLink href={'/'} aria-label="Tuatahi First Fibre home" passHref>
              <PrismicNextImage className="" field={core.data.small_logo} fallbackAlt="" />
            </NextLink>
          </div>
          <div className="hidden md:flex col-span-4 justify-center">
            {page?.uid !== null && (
              <NextLink href={'/address-checker'} passHref>
                <button
                  type="button"
                  className="border-[1px] border-jade rounded-full p-[5px] px-4 text-[12px] leading-[12px] cursor-pointer hover:opacity-60"
                >
                  Check fibre availability
                </button>
              </NextLink>
            )}
          </div>
          <div className="col-span-6 md:col-span-4 flex justify-end">
            <button
              type="button"
              aria-label={searchState ? "Close search" : "Open search"}
              className={"mx-8 min-w-[44px] min-h-[44px] flex items-center justify-center cursor-pointer hover:opacity-60 " + searchState}
              onClick={() => {
                setSearchState(!searchState)
                document.body.style.overflow = "hidden"
              }}
            >
              <SearchButton />
            </button>
            <button
              type="button"
              aria-label={menuState ? "Close menu" : "Open menu"}
              className={"min-w-[44px] min-h-[44px] flex items-center justify-center cursor-pointer hover:opacity-60 " + menuState}
              onClick={() => {
                setMenuState(!menuState)
                document.body.style.overflow = "hidden"
              }}
            >
              <MenuButton />
            </button>
          </div>
        </div>
        {menuState && <MegaNav core={core} setMenuState={setMenuState} sections={sections} />}
        {searchState && <Search core={core} setSearchState={setSearchState} />}
      </div>
    </header>
  )
}

export default Header;
